import React, { Component } from "react";
import { Glyphicon, Grid, Row, Col, Modal, Button } from "react-bootstrap";
import ContactForm from './ContactForm';
import './Contact.css';

export default class Contact extends Component {
  constructor(props) {
  	super(props);
  	this.state = {
      show: false
  	};
  }

  handleClickMap = (evt) => {
    evt.preventDefault();
    this.setState({show: true});
  }

  handleCloseMap = () => {
    this.setState({show: false});
  }

  render() {
    return (
      <div className="Contact">
        <Grid>
          <h3 className="title">Contacto</h3>
          <Row>
            <Col md={6}>
              <div>
                <h3>Vis&iacute;tanos</h3>
                <p>
                  <Glyphicon glyph='map-marker' /> <a href="#address" onClick={this.handleClickMap}>Dr. Manuel Barros Borgoño 71, Of 1105 11p, Providencia, Región Metropolitana</a>
                </p>
              </div>
              <hr/>
              <div>
                <h3>Ll&aacute;manos</h3>
                <p>
                  <Glyphicon glyph='phone' /> <a href="tel:+56988147296">+56 9 8814 7296</a>
                </p>
              </div>
              <hr/>
              <div>
                <h3>Escr&iacute;benos</h3>
                <p>
                  <Glyphicon glyph='envelope' /> <a href="mailto:contacto@pizarrovial.cl" target="_blank" rel="noopener noreferrer">contacto@pizarrovial.cl</a>
                </p>
                <p>
                  <Glyphicon glyph='envelope' /> <a href="mailto:licitacion@pizarrovial.cl" target="_blank" rel="noopener noreferrer">licitacion@pizarrovial.cl</a>
                </p>
              </div>
            </Col>
            <Col md={6}>
              <ContactForm />
            </Col>
          </Row>
          <Modal show={this.state.show} onHide={this.handleCloseMap} className="modalMap">
            <Modal.Header>
              <Modal.Title>Nuestra ubicaci&oacute;n</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe title="Mapa" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAEIpgj38KyLFELm2bK9Y7krBkz1K-cMq8&q=place_id:El1Eci4gTWFudWVsIEJhcnJvcyBCb3Jnb8OxbyA3MSwgb2YgMTEwNSAxMXAsIDc1MDA1OTMgUHJvdmlkZW5jaWEsIFJlZ2nDs24gTWV0cm9wb2xpdGFuYSwgQ2hpbGUiJxolChYKFAoSCXtmGtR8z2KWEQGBcAlJ7H6SEgtvZiAxMTA1IDExcA" width="600" height="450" frameBorder="0" style={{border:0}} allowFullScreen></iframe>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleCloseMap}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Contact.js